import {useFormContext} from 'react-hook-form'
import {Label} from './Label'
import {ChangeEventHandler} from 'react'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Unique id. default: 'checkbox'+Math.random()
   */
  id?: string
  /**
   * Input name
   */
  name: string
  /**
   * Input Label
   */
  label?: string
  /**
   * Extra info will be shown next to label
   */
  info?: string
  /**
   * Position of check input against label
   */
  labelPosition?: 'left' | 'right'

  disabled?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
  checked?: boolean
}

export const CheckBox = ({
  id = 'checkbox-' + Math.random(),
  label,
  name,
  info,
  labelPosition = 'right',
  onChange,
  disabled,
  checked = false,
}: Props) => {
  const {
    register,
    formState: {errors},
  } = useFormContext()
  const error = errors[name] as any
  return (
    <div className="flex items-start relative">
      <div
        className="customCheckBox focus-within:text-focus flex items-center h-5
        ">
        {label && labelPosition === 'left' && (
          <Label
            label={label}
            info={info}
            className="text-xs font-light mr-2.5 -mb-0"
            htmlFor={id}
          />
        )}
        <input
          id={id}
          // className="h-4 w-4 opacity-0 absolute"
          type="checkbox"
          checked={checked}
          {...(name ? register(name) : {})}
          {...(onChange ? {onChange: onChange} : {})}
          disabled={disabled}
          // defaultChecked={checked}
          onChange={onChange}
        />
        {/* <div
          className={`bg-white border-2 rounded border-form-border w-5 h-5 
            flex flex-shrink-0 justify-center items-center ${className}`}>
          <i className="icon-ok text-sm pointer-events-none" />
        </div> */}
        {label && labelPosition === 'right' && (
          <Label
            htmlFor={id}
            label={label}
            info={info}
            className="text-xs font-light ml-2.5 -mb-0"
          />
        )}
      </div>
      {error && <p className="text-alert pt-1.5 text-xs">{error}</p>}
    </div>
  )
}
